import { render } from "./queue-comp.vue?vue&type=template&id=95c6dd86&scoped=true"
import script from "./queue-comp.vue?vue&type=script&lang=js"
export * from "./queue-comp.vue?vue&type=script&lang=js"

import "./queue-comp.vue?vue&type=style&index=0&id=95c6dd86&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c6dd86"]])

export default __exports__